function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".a{fill:#18efa4;}.b{fill:#18ea95;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("g", {
  transform: "translate(44.714 34.22)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826,
  transform: "translate(1.826 0) rotate(90)"
})), React.createElement("g", {
  transform: "translate(58.013)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826,
  transform: "translate(1.826 0) rotate(90)"
})), React.createElement("g", {
  transform: "translate(21.901 11.407)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826,
  transform: "translate(1.826 0) rotate(90)"
})), React.createElement("g", {
  transform: "translate(33.308 22.814)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826,
  transform: "translate(1.826 0) rotate(90)"
})), React.createElement("g", {
  transform: "translate(0 0.749)"
}, React.createElement("rect", {
  className: "b",
  width: 58.926,
  height: 0.328
})), React.createElement("g", {
  transform: "translate(0 12.156)"
}, React.createElement("rect", {
  className: "b",
  width: 22.814,
  height: 0.328
})), React.createElement("g", {
  transform: "translate(0 23.562)"
}, React.createElement("rect", {
  className: "b",
  width: 34.22,
  height: 0.328
})), React.createElement("g", {
  transform: "translate(0 34.969)"
}, React.createElement("rect", {
  className: "b",
  width: 45.627,
  height: 0.328
})));

var SvgSupplyChainOptimization = function SvgSupplyChainOptimization(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 59.839,
    height: 36.046,
    viewBox: "0 0 59.839 36.046",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSupplyChainOptimization, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Supply_Chain_Optimization.3bbb55ff.svg";
export { ForwardRef as ReactComponent };